import { ReactNode } from "react";

import Spinner from "components/Spinner";

import "./ViewerList.css";
import "./ListColumns.css";
import "./ViewerListsTableView/TableView.css";

type ListLayoutProps = {
  navigation: ReactNode;
  filters: ReactNode;
  table: ReactNode;
  pagination: ReactNode;

  resourceCount?: number;
  errorMessage?: string;
  isListLoading?: boolean;
};

const ListLayout = ({
  navigation,
  filters,
  table,
  pagination,

  resourceCount,
  errorMessage = "There are no records to display",
  isListLoading,
}: ListLayoutProps) => {
  return (
    <>
      <div className="ViewerList__navContainer">{navigation}</div>
      <>
        {filters}
        <>
          {isListLoading ? (
            <Spinner />
          ) : resourceCount ? (
            <>
              <div style={{ overflowX: "auto" }}>{table}</div>
              {pagination}
            </>
          ) : (
            <div className="ViewerList__emptyList">
              <span>{errorMessage}</span>
            </div>
          )}
        </>
      </>
    </>
  );
};

export default ListLayout;
